import { IDownloadInfoEntregaObraClienteArquivoByIdUseCase } from "../../../presentation/useCases/read/download_info_entrega_obra_cliente_arquivo_by_id_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DownloadInfoEntregaObraClienteArquivoByIdUseCase
 */

export class DownloadInfoEntregaObraClienteArquivoByIdUseCase
  implements IDownloadInfoEntregaObraClienteArquivoByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async downloadInfoEntregaObraClienteArquivoById(
    idInformacoesEntregaObraCliente: number,
    imageName: string,
    nrArquivo: number,
    isDownload: boolean,
  ): Promise<Blob> {
    const blob = await this.repository.downloadInfoEntregaObraClienteArquivoById(idInformacoesEntregaObraCliente, nrArquivo);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    if (isDownload) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', String(imageName));
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }

    return blob;
  }
}
